import { Flex, Image, useColorMode } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getLocationSelectPagePath } from '../../App';
import Button from '../../components/button';
import IconCard from '../../components/icon-card';
import Layout from '../../components/layout';
import Text from '../../components/text';
import { useSession } from '../../hooks/useSession';
import Logos from '../../images/logos';

export default function SecurityMessagePage() {
    const session = useSession();
    const { push } = useHistory();
    const { colorMode, toggleColorMode } = useColorMode();

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
            buttons={
                <Button
                    onClick={() =>
                        push(getLocationSelectPagePath(session?.cid!))
                    }
                    w="full"
                >
                    Continue
                </Button>
            }
        >
            <Flex
                direction="column"
                align="center"
                gap="24px"
                w="full"
                textAlign="center"
            >
                <Image
                    w="auto"
                    h="45px"
                    src={Logos[colorMode]['ss']}
                    alt="SharpSports"
                />
                <Text>
                    <Text as="strong">{session?.user?.name}</Text> uses{' '}
                    <Text as="strong">SharpSports</Text> to link your <br />{' '}
                    Sportsbook Account
                </Text>
                <Flex
                    justify="center"
                    align="center"
                    position="relative"
                    h="140px"
                    w="350px"
                >
                    <Image
                        src="/images/onboarding/entry-picture.png"
                        srcSet="/images/onboarding/entry-picture.png 1x, /images/onboarding/entry-picture@2x.png 2x"
                    />
                    {/* <Image
                    position="absolute"
                    top="32px"
                    right="52px"
                    transform="rotate(34deg) skew(-24deg, 0deg)"
                    w="50px"
                        h="50px"
                        objectFit="contain"
                        src={session?.logoUrl || ""}
                    /> */}
                    <Image
                        position="absolute"
                        top="9px"
                        right="48px"
                        w="50px"
                        h="50px"
                        objectFit="contain"
                        src="/images/onboarding/user.png"
                        srcSet="/images/onboarding/user.png 1x, /images/onboarding/user@2x.png 2x"
                    />
                </Flex>
                <Flex justify="center" gap="16px" mb="40px">
                    <IconCard
                        icon="/images/icons/shield-icon.svg"
                        title="Secure"
                        description="Encryption protects your personal data"
                    />
                    <IconCard
                        icon="/images/icons/hacker-icon.svg"
                        title="Private"
                        description={`Your credentials are never made accessible to ${
                            session?.user?.name || 'this application'
                        }`}
                    />
                </Flex>
            </Flex>
        </Layout>
    );
}
